export const projects = {
  // Page Title
  pageTitle: "Onze Realisaties",
  pageSubtitle: "Ontdek enkele van onze voltooide renovatie- en bouwprojecten in Brussel en omgeving",
  
  // Filter Categories
  filterAll: "Alle",
  filterApartment: "Appartement",
  filterHouse: "Huis",
  filterBathroom: "Badkamer",
  filterKitchen: "Keuken",
  
  // Loading & Empty States
  loading: "Laden...",
  noProjects: "Geen projecten gevonden",
  noProjectsDesc: "Er zijn momenteel geen projecten beschikbaar in deze categorie",
  
  // Stats Section
  projectsCompleted: "Voltooide Projecten",
  yearsExperience: "Jaar Ervaring",
  satisfiedClients: "Tevreden Klanten",
  projectsDelivered: "Projecten Opgeleverd",
  
  // CTA Section
  ctaTitle: "Heeft u een project in gedachten?",
  ctaText: "Neem vandaag nog contact met ons op voor een gratis en persoonlijke offerte. Wij begeleiden u van het eerste idee tot de definitieve oplevering",
  ctaButton: "Vraag een gratis offerte aan",
  
  // Project Details
  projectType: "Type Project",
  location: "Locatie",
  duration: "Duur",
  surface: "Oppervlakte",
  budget: "Budget",
  year: "Jaar",
  client: "Klant",
  
  // Project Types
  renovation: "Renovatie",
  extension: "Uitbreiding",
  newBuild: "Nieuwbouw",
  roofing: "Dakwerken",
  interior: "Interieur",
  exterior: "Exterieur",
  bathroom: "Badkamer",
  kitchen: "Keuken",
  
  // Project Status
  completed: "Voltooid",
  inProgress: "In Uitvoering",
  planned: "Gepland",
  
  // Project Categories
  residential: "Residentieel",
  commercial: "Commercieel",
  industrial: "Industrieel",
  
  // Gallery
  viewGallery: "Bekijk Galerij",
  viewProject: "Bekijk Project",
  projectDetails: "Projectdetails",
  beforeAfter: "Voor & Na",
  
  // Featured Projects
  featuredTitle: "Uitgelichte Projecten",
  featuredDescription: "Een selectie van onze meest recente en opvallende realisaties",
  
  // Testimonials
  testimonialsTitle: "Wat Onze Klanten Zeggen",
  testimonial1: "Ktran heeft ons huis prachtig gerenoveerd. Professioneel werk en uitstekende communicatie!",
  testimonial1Author: "Marc & Sophie",
  testimonial2: "De uitbreiding is perfect geworden. Het team werkte netjes en respecteerde alle afspraken.",
  testimonial2Author: "Peter Janssens",
  testimonial3: "Onze nieuwe badkamer is een droom! Dank aan het hele team voor het mooie resultaat.",
  testimonial3Author: "Lisa Vermeulen",
  
  // Load More
  loadMore: "Meer Projecten Laden",
  noMoreProjects: "Geen Projecten Meer",
  
  // Search & Sort
  searchPlaceholder: "Zoek projecten...",
  sortBy: "Sorteren op",
  sortNewest: "Nieuwste Eerst",
  sortOldest: "Oudste Eerst",
  sortNameAZ: "Naam (A-Z)",
  sortNameZA: "Naam (Z-A)"
};
